import { useEffect, useState } from 'react'
import { styled } from 'styled-components'

const CardWrapper = styled.div`
    border: 1px solid #e6e6e6;
    border-radius: 8px;
    padding: 20px;
    width: 400px;
`

const Img = styled.img`
    width: 100%;
    height: 250px;
    object-fit: cover;
    border-radius: 8px;
`

const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-top: 10px;
`

const Button = styled.a`
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    background-color: #31c690;
    width: fit-content;
    color: white;
    text-decoration: none;
    &:hover {
        cursor: pointer;
        background-color: #28a67a;
    }
`

export default function Card({
    label,
    image,
    text,
}: {
    label?: string
    image?: string
    text?: { p1: string; p2: String; link: string }
}) {
    return (
        <CardWrapper>
            {image && <Img src={image} alt="Card" />}
            <ContentWrapper>
                {label && <h3>{label}</h3>}
                {text && <p>{text.p1}</p>}
                <p>Achievement standard</p>
                {text && <p>{text.p2}</p>}
                {text && (
                    <Button href={text.link} target="_blank">
                        Learn More
                    </Button>
                )}
            </ContentWrapper>
        </CardWrapper>
    )
}
